export function fetchCourses(lang = 'en') {
  const url = `/wp-json/wp/v2/course?per_page=100&lang=${lang}`
  // console.log(url)
  const results = fetch(url).then(r => r.json());
  console.log('fetchCourses', { url, results })
  return results
}
